import { API_BASE_URL, origin } from "./Constant";
import Axios from "axios";
import { dataDisplayRequest } from "./auth_service/AuthServiceHelper";

export default class AxiosService {
  constructor() {}

  getAllDataForProject(projectId){
    const config={
      method: "post",
      url:API_BASE_URL + `/v1/api/getAllDataForProject?projectId=${projectId}`,
      data:{},
    };
    return dataDisplayRequest(config).then((response)=>{
      return response;
    });
  }

  getProjectList() {
    const config = {
      method: "get",
      url: API_BASE_URL + `/v1/api/getProjects`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getTotalCountByProject(projectId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getTotalPatentsForProject?projectId=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getSimilarDataForManuscriptId(manuscriptId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getSimilarDataForManuscriptId?manuscriptId=${manuscriptId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getCurationDataForManuscriptId(manuscriptId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getCurationDataForManuscriptId?manuscriptId=${manuscriptId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFinalStatusForManuscriptId(manuscriptId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getFinalStatusForManuscriptId?manuscriptId=${manuscriptId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getSimilarAndApprovedDataForManuscriptId(manuscriptId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getSimilarAndApprovedDataForManuscriptId?manuscriptId=${manuscriptId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDashboardDataCount(projectName, userName, filters,assignedId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getDashboardDataCount`,
      data: {
        projectName: projectName,
        userName: userName,
        filters: filters,
        assignedId: assignedId,
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDashboardData(projectName, userName, pageNo, filters,assignedId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getDashboardData`,
      data: {
        projectName: projectName,
        userName: userName,
        pageNo: pageNo,
        filters: filters,
        assignedId: assignedId
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  setStatusForManuscript(manuscript, status, id, comment, doi, title) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/setStatusForManuscript?manuscript=${manuscript}&status=${status}&id=${id}&comment=${comment}&doi=${doi}&submissionTitle=${title}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  revertStatusForManuscript(manuscript, comment) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/revertStatusForManuscript?manuscript=${manuscript}&comment=${comment} `,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getAssignedUserDetailsCount(projectName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/getAssignedUserDetailsCount?projectId=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getAssignedUserDetails(projectName, pageNo) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/getAssignedUserDetails?projectId=${projectName}&pageNo=${pageNo}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  reAssign(curatorName, dueDate, count, assignedId, reassignToAssigned) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/reAssign?curatorName=${curatorName}&dueDate=${dueDate}&count=${count}&assignedId=${assignedId}&reassignToAssigned=${reassignToAssigned}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  // getTotalCountByProject(projectId) {
  //   const config = {
  //     url: `${API_BASE_URL}/api/v1/getTotalPatentsForProject/${projectId}`,
  //     method: "get",
  //   };
  //   return dataDisplayRequest(config).then((res) => {
  //     return res;
  //   });
  // }

  //venu endpoints
  searchData(curatorName, projectName, page, searchText, filterData,assignedId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/search`,
      data: {
        curatorName: curatorName,
        projectName: projectName,
        page: page,
        searchText: searchText,
        filters: filterData,
        assignedId: assignedId
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  // 1. POST /searchCount
  searchCount(curatorName, projectName, page, searchText, filterData, assignedId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/searchCount`,
      data: {
        curatorName: curatorName,
        projectName: projectName,
        page: page,
        searchText: searchText,
        filterData: filterData,
        assignedId: assignedId
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  // 2. GET /getSimilarDataForPreviousOrNextManuscript
  getSimilarDataForPreviousOrNextManuscript(button, manuscriptId, filters) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getSimilarDataForPreviousOrNextManuscript`,
      data: {
        button: button,
        manuscriptId: manuscriptId,
        filters: filters,
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  // 3. POST /getCurationDataForPreviousOrNextManuscript
  getCurationDataForPreviousOrNextManuscript(button, manuscriptId, filters) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getCurationDataForPreviousOrNextManuscript`,
      data: {
        button: button,
        manuscriptId: manuscriptId,
        filters: filters,
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  // 4. POST /completeAllManuscripts
  completeAllManuscripts(assignedId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/completeAllManuscripts?assignedId=${assignedId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getTotalCountByProjectAndThreshold(projectId, threshold) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getTotalPatentsForProject?projectId=${projectId}&threshold=${threshold}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPendingCountByProjectAndThreshold(projectId, threshold) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getPendingPatentsForProject?projectId=${projectId}&threshold=${threshold}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  assign(assignDto) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/assign`,
      headers: {
        "Content-Type": "application/json",
      },
      data: assignDto,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getCuratorList(mode) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/v1/api/users?mode=${mode}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDistinctThresholdByProject(projectName) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getDistinctThresholdByProject?projectId=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getOrderOfManuscript(manuscriptId) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/getManuscriptCounter?manuscriptId=${manuscriptId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  checkFreezeStatus(assignedId) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/v1/api/checkFreezeStatus?assignedId=${assignedId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiProcessedStatusByLlmTitleScore(
    fromRange,
    toRange,
    action,
    projectName
  ) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateLlmTitleScoreStatus?fromRange=${fromRange}&toRange=${toRange}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiProcessedStatusByLlmAuthorScore(
    fromRange,
    toRange,
    action,
    projectName
  ) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateLlmAuthorScoreStatus?fromRange=${fromRange}&toRange=${toRange}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiProcessedStatusByLlmTitleAndAuthorScore(
    titleFromRange,
    titleToRange,
    authorFromRange,
    authorToRange,
    action,
    projectName
  ) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateLlmAuthorScoreAndTitleScoreStatus?titleFromRange=${titleFromRange}&titleToRange=${titleToRange}&authorFromRange=${authorFromRange}&authorToRange=${authorToRange}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiProcessedStatusByAuthorStatus(type, action, projectName) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateAuthorStatusFlagStatus?type=${type}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiProcessedStatusByDateFlag(type, action, projectName) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateDateFlagStatus?type=${type}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiProcessedStatusByAuthourAndDateFlag(
    authourFlag,
    dateFlag,
    action,
    projectName
  ) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateAuthorStatusAndDateFalgStatus?authourFlag=${authourFlag}&dateFlag=${dateFlag}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  saveSimilarAcceptedManuscriptComment(manuscriptId, id, comment) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateCommentForManuscriptAndObjectId?manuscriptId=${manuscriptId}&id=${id}&comment=${comment}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getProjectStatusReport(projectId) {
    const config = {
      method: "get",
      url:
        API_BASE_URL + `/v1/api/getProjectStatusDetails?projectId=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getCommentDashboardData(projectName, userName, filters, assignedId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getCommentDashboardData`,
      data: {
        projectName: projectName,
        userName: userName,
        filters: filters,
        assignedId: assignedId
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getUserLogData(projectName, userName, filters) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getCuratorDashboardData`,
      data: {
        projectName: projectName,
        userName: userName,
        filters: filters,
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  doiSubmissionTitleValidation(doi, submissionTitle) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/doiSubmissionTitleValidation?doi=${doi}&submissionTitle=${submissionTitle}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFinalExportReport(projectId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getFinalExportReport?projectId=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDistinctLlmTitleScores(projectId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getDistinctLlmTitleScores?projectId=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDistinctLlmAuthourScores(projectId) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getDistinctLlmAuthourScores?projectId=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getCommentReport(projectId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getCommentReport?projectId=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getAllDoiFilters() {
    const config = {
      method: "post",
      url: API_BASE_URL + `/v1/api/getAllDoiFilters`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiFlagStatus(projectId, action, doi) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateDoiFlagStatus?doi=${doi}&action=${action}&projectName=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDoiReport(doi, projectId) {
    console.log(projectId, "----->>>", doi);
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getDoiReport?doi=${doi}&projectName=${projectId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getAllJournals(project) {
    const config = {
      method: "post",
      url:
        API_BASE_URL + `/v1/api/getAllJournalsForProject?projectId=${project}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateJournalFlagStatus(journal, action, projectName) {
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateJournalFlagStatus?journal=${journal}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateDoiFlagStatusForManuscripts(allDoiWithManuscripts, action, projectName) {
    console.log(allDoiWithManuscripts, action, projectName);
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/updateDoiFlagStatusForManuscripts?allDoiWithManuscripts=${allDoiWithManuscripts}&action=${action}&projectName=${projectName}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getJournalReport(journal,projectName) {
    const finalJournal = encodeURIComponent(journal);
    const config = {
      method: "post",
      url:
        API_BASE_URL +
        `/v1/api/getJournalReport?projectName=${projectName}&Journal=${finalJournal}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getCuratorDataForProject(projectId, userName) {    
    const config = {
  method: "post",
  url:
    API_BASE_URL +
    `/v1/api/getCuratorDataForProject?projectId=${projectId}&userName=${userName}`,
  data: {},
};
return dataDisplayRequest(config).then((response) => {
  return response;
});
}

}
